<template lang="pug">
  section.backgroundLogin.hero.is-fullheight.is-primary
    .hero-body
      .container
        .columns.is-centered
          .column.is-6-tablet.is-5-desktop.is-4-widescreen
            transition(name="fade" mode="out-in")
              form.box(name="loginForm" @submit.preventDefault="handleSubmit" v-if="!recovery")

                h3.is-size-3.has-text-centered.has-text-grey(style="margin-bottom: 15px;") Inicio de sesión

                .field
                  label.label(for="emailInput") Correo *
                  .control.has-icons-left
                    input#emailInput.input(v-model="login.email" type="email" placeholder="e.g. algien@email.com" required)
                    span.icon.is-small.is-left
                      i.fa.fa-envelope

                .field
                  label.label(for="passInput") Contraseña *
                  .control.has-icons-left
                    input#passInput.input(v-model="login.password" type="password" placeholder="*******" required)
                    span.icon.is-small.is-left
                      i.fa.fa-lock

                .field
                  .buttons
                    button.button.is-success(:class="{ 'is-loading': loading }") Entrar
                    button.button.is-info.is-outlined(type="button" @click="recovery = true") Recuperar Contraseña

              form.box(name="loginForm" @submit.preventDefault="handleSubmitRecovery" v-else)

                h3.is-size-3.has-text-centered.has-text-grey(style="margin-bottom: 15px;") Recuperación de contraseña

                .field
                  label.label(for="emailInput") Correo *
                  .control.has-icons-left
                    input#emailInput.input(v-model="login.email" type="email" placeholder="e.g. bobsmith@gmail.com" required)
                    span.icon.is-small.is-left
                      i.fa.fa-envelope
                  p.help Se enviará un enlace al correo electrónico con el proceso de restablecimiento.

                .field(style="margin-top: 30px;")
                  .buttons
                    button.button.is-success(:class="{ 'is-loading': loading }") Recuperar
                    button.button.is-info.is-outlined(type="button" @click="recovery = false" style="margin-left: 7px;") Volver

</template>

<style scoped>
.loginCharging {
  color: #0095ff;
  padding: 15px;
  font-size: 2rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>

<script>
import { mapActions } from "vuex";

export default {
  name: "login_view",

  data: () => ({
    login: {
      email: "",
      password: ""
    },
    loading: false,
    recovery: false
  }),

  mounted() {
    // window.VANTA.CLOUDS({
    //   el: ".backgroundLogin"
    // });
  },

  methods: {
    ...mapActions(["loginAction", "restoreAction"]),
    async handleSubmit() {
      if (this.loading) return;
      this.loading = true;
      try {
        await this.loginAction(this.login);
        this.$toastr("success", "Inicio de sesión exitoso.");
      } catch (err) {
        console.error(err);
        this.$toastr(
          "error",
          "No se puede iniciar sesión. Verifique su usuario y contraseña o pongase en contacto con el administrador."
        );
      }
      this.loading = false;
    },
    async handleSubmitRecovery() {
      try {
        await this.restoreAction(this.login);
        this.$toastr(
          "success",
          "Solicitu de recuperación exitosa. Por favor verifique su bandeja de correo."
        );
      } catch (err) {
        console.error(err);
        this.$toastr(
          "error",
          "No se puede hacer la recuperación. Pongase en contacto con el administrador."
        );
      }
    }
  }
};
</script>
